
import Vue from 'vue';
// eslint-disable-next-line import/extensions, import/no-unresolved
import { CSSProperties } from 'vue/types/jsx';
import { SpinnerLoading } from '../SpinnerLoading';

export default Vue.extend({
  components: { SpinnerLoading },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    shape: {
      type: String,
      required: false,
      default: 'default',
    },
    theme: {
      type: String,
      required: false,
      default: 'primary',
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    currentWidth: 0,
    currentHeight: 0,
  }),
  computed: {
    themeClassName(): string {
      if (this.shape === 'none' || this.theme === 'none') {
        return '';
      }

      return `btn__${this.shape}--${this.theme}`;
    },
    style(): CSSProperties {
      const style: CSSProperties = {};

      if (this.fullWidth) {
        style.width = '100%';
      }

      if (this.loading && this.currentWidth > 0 && this.currentHeight > 0) {
        style.width = `${this.currentWidth}px`;
        style.height = `${this.currentHeight}px`;
      }

      return style;
    },
  },
  async mounted() {
    await this.$nextTick();
    this.setCurrentSize();

    new globalThis.ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect != null) {
          this.setCurrentSize();
        }
      });
    }).observe(this.$el);
  },
  methods: {
    setCurrentSize() {
      if (!this.loading) {
        const { width, height } = this.$el.getBoundingClientRect();
        if (width > 0 && height > 0) {
          this.currentWidth = width;
          this.currentHeight = height;
        }
      }
    },
  },
});
